import { Record, RecordOf } from 'immutable';

import { StandardAction } from '../types';
import SearchAction from './search.actions';
import { ISearchState } from './types';

const initData: ISearchState = {
  transactionSearch: {},
  error: '',
  isFetching: false,
  currentSearchInput: '',
};

const initialState = Record(initData)(initData);

export default class SearchReducer {
  static getReducer(state: RecordOf<ISearchState> = initialState, action: StandardAction): RecordOf<ISearchState> {
    switch (action.type) {
      // Upload Search
      case SearchAction.TYPES.FETCH_SEARCH_SUGGESTION.START:
      case SearchAction.TYPES.FETCH_SEARCH_SUGGESTION.SUCCESS:
      case SearchAction.TYPES.FETCH_SEARCH_SUGGESTION.FAILURE:
        return SearchReducer.handleFetchSuggestion(state, action);

      default:
        return state;
    }
  }

  // handle upload search
  static handleFetchSuggestion = (state: RecordOf<ISearchState>, action: StandardAction): RecordOf<ISearchState> => {
    switch (action.type) {
      case SearchAction.TYPES.FETCH_SEARCH_SUGGESTION.START:
        return {
          ...state,
          isFetching: true,
          error: '',
          currentSearchInput: action.payload.searchInput,
        };

      case SearchAction.TYPES.FETCH_SEARCH_SUGGESTION.SUCCESS:
        return {
          ...state,
          transactionSearch: { ...state.transactionSearch, [action?.payload?.searchInput || '']: action?.payload.data },
          isFetching: false,
          error: '',
        };

      case SearchAction.TYPES.FETCH_SEARCH_SUGGESTION.FAILURE:
        return {
          ...state,
          isFetching: false,
          error: action.error || '',
        };

      default:
        return state;
    }
  };
}
